import React from "react";
import "./SacredCommunity.css";

import { FaInstagram, FaHeart } from "react-icons/fa";
import { INSTAGRAM_URL } from "../../constants/socialLinks";

const gallery = [
  {
    image:
      "https://i.pinimg.com/1200x/54/6b/cf/546bcf5c01debc2083b014b3ece26818.jpg",
    title: "पूजा का समय 🙏",
    likes: "2.4k",
  },
  {
    image:
      "https://i.pinimg.com/736x/b9/19/05/b919056260a7539bfdfedde13d4e4259.jpg",
    title: "घर में मंगल आया ✨",
    likes: "1.8k",
  },
  {
    image:
      "https://i.pinimg.com/1200x/dc/d0/60/dcd0603a1317ab60ce37c84f3ce29a87.jpg",
    title: "सुगंध से भरा घर 🪔",
    likes: "3.2k",
  },
  {
    image:
      "https://i.pinimg.com/736x/5e/c5/e8/5ec5e8bab1492a71b402219bf412cc81.jpg",
    title: "शंखनाद से हुई सुबह 🐚",
    likes: "950",
  },
  {
    image:
      "https://i.pinimg.com/736x/f7/5c/7e/f75c7eb75d09edef1cf9accba2f84442.jpg",
    title: "दिव्य ऊर्जा का स्रोत 🔱",
    likes: "1.4k",
  },
  {
    image:
      "https://i.pinimg.com/1200x/1e/a8/8f/1ea88f7983285ac2134f0d2d8a8c3ded.jpg",
    title: "काशी की पहचान 🌺",
    likes: "5.1k",
  },
  {
    image:
      "https://i.pinimg.com/1200x/bc/b8/0d/bcb80d44a5e9b22936eb75c9ee4178a7.jpg",
    title: "काशी विश्वनाथ दरबार 🛕",
    likes: "4.8k",
  },
  {
    image:
      "https://i.pinimg.com/736x/9f/af/4e/9faf4e6aafd12e3d283bd5ff176211b9.jpg",
    title: "शिव का वरदान 📿",
    likes: "2.9k",
  },
];

export default function SacredCommunity() {
  return (
    <section className="community">
      <div className="community-heading">
        <div className="community-heading-left">
          <span>COMMUNITY & DEVOTEES</span>
          <h2>Our Sacred Community</h2>
            <div className="about-heading-line">
          <img
            src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
            alt="Heading decoration"
          />
        </div>
          <p>
            Thousands of devotees share their sacred journey with us. Tag your
            photos to be featured here.
          </p>
        </div>
    
      </div>
      <div className="community-slider">

        <div className="community-track">

          {/* ORIGINAL CARDS */}
          {gallery.map((item, index) => (
            <div
              className="community-card"
              key={`original-${index}`}
            >

              <img
                src={item.image}
                alt={item.title}
              />

              {/* IMAGE INSTAGRAM BUTTON */}
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="community-image-instagram"
                aria-label="View on Instagram"
              >
                <FaInstagram />
              </a>


              {/* HOVER OVERLAY */}
              <div className="community-overlay">

                <FaInstagram className="instaIcon" />

                <h4>{item.title}</h4>

                <span>
                  <FaHeart />
                  {item.likes}
                </span>

              </div>

            </div>
          ))}


          {/* DUPLICATE CARDS FOR INFINITE LOOP */}
          {gallery.map((item, index) => (
            <div
              className="community-card"
              key={`duplicate-${index}`}
            >

              <img
                src={item.image}
                alt={item.title}
              />

              {/* IMAGE INSTAGRAM BUTTON */}
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="community-image-instagram"
                aria-label="View on Instagram"
              >
                <FaInstagram />
              </a>


              {/* HOVER OVERLAY */}
              <div className="community-overlay">

                <FaInstagram className="instaIcon" />

                <h4>{item.title}</h4>

                <span>
                  <FaHeart />
                  {item.likes}
                </span>

              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
}